import type { PanelMemberPatchDto, PanelStatus } from "../../autogen/bff-api";

type PanelEdit = { ranking?: number | null; status?: PanelStatus };

export type PanelEdits = {
  record: (organizationId: string, edit: PanelEdit) => void;
  pending: () => PanelMemberPatchDto[];
  clear: (sent: PanelMemberPatchDto[]) => void;
  discard: () => void;
};

export const createPanelEdits = (): PanelEdits => {
  const edits = new Map<string, PanelEdit>();
  return {
    record: (organizationId, edit) => {
      edits.set(organizationId, { ...edits.get(organizationId), ...edit });
    },
    pending: () => [...edits.entries()].map(([organizationId, edit]) => ({ organizationId, ...edit })),
    clear: (sent) => {
      sent.forEach((member) => {
        const current = edits.get(member.organizationId);
        if (current && current.ranking === member.ranking && current.status === member.status) {
          edits.delete(member.organizationId);
        }
      });
    },
    discard: () => edits.clear(),
  };
};
